import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Header.css";
import logo from "../../images/gazipurriders.png";

const Header = () => {
  return (
    <div className="container">
    <nav className="container navbar navbar-expand-lg navbar-light bg-light">
        <Link to="/" className="navbar-brand">
            <img className="logo" src={logo} alt="" />
        </Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ml-auto">
                <li className="nav-item ">
                    <Link to="/home" className="nav-link">Home <span className="sr-only">(current)</span></Link>
                </li>
                <li className="nav-item">
                    <Link to="/destination" className="nav-link" >Destination</Link>
                </li>
                <li className="nav-item">
                    <Link to="/blog" className="nav-link" >Blog</Link>
                </li>
                <li to className="nav-item">
                    <Link to="/contact" className="nav-link">Contact</Link>
                </li>
                <li className="nav-item">
                <Button variant="success"><Link to="/login">Login</Link></Button>
                </li>
                
           </ul>
            
        </div>
    </nav>
</div>
);
};

export default Header;